import { useState, useEffect } from 'react';
import { useT } from '../../i18n/index.jsx';

/**
 * OfflineIndicator — Zeigt Offline/Online-Status als Banner an.
 *
 * Hört auf `window.online`/`offline` Events. Der "Wieder online"-Banner
 * verschwindet automatisch nach 3 Sekunden.
 */
export function OfflineIndicator() {
  const t = useT();
  const [online, setOnline] = useState<boolean>(navigator.onLine);
  const [showOnline, setShowOnline] = useState<boolean>(false);

  useEffect(function () {
    const onOff = function () {
      setOnline(false);
    };
    const onOn = function () {
      setOnline(true);
      setShowOnline(true);
      setTimeout(function () {
        setShowOnline(false);
      }, 3000);
    };
    window.addEventListener('offline', onOff);
    window.addEventListener('online', onOn);
    return function () {
      window.removeEventListener('offline', onOff);
      window.removeEventListener('online', onOn);
    };
  }, []);

  if (!online)
    return (
      <div className="offline-bar" style={{ background: '#ef4444', color: '#fff' }}>
        {t('mobileOffline')}
      </div>
    );
  if (showOnline)
    return (
      <div
        className="offline-bar"
        style={{ background: 'var(--accent)', color: '#fff' }}>
        {t('mobileOnline')}
      </div>
    );
  return null;
}
